/**
 * will prepend api base url
 * e.g. /order/fetch
 * @param endpoint api endpoint path
 */
export const apiURL = (endpoint: string) => {
  return `${process.env.API_URL}/${process.env.API_VER}${endpoint}`;
}